import React from 'react'
import styles from './OptionCard.module.css'

const OptionCard = ({ icon, label, onClick, disabled = false }) => {
    return (
        <div
            className={`${styles.card} ${disabled ? styles.disabled : ''}`}
            onClick={disabled ? undefined : onClick}
            aria-disabled={disabled}
        >
            <div className={styles.iconWrap}>
                <img src={icon} alt={label} />
            </div>
            <p className={styles.label}>{label}</p>
        </div>
    )
}

export default OptionCard
